import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import './settings.scss';

/**
 * Custom tabs component for settings pages
 * Usage:
 * <SettingsTabs
 *   tabs={[
 *     { id: 'tab1', label: 'Tab 1', content: <Component1 /> },
 *     { id: 'tab2', label: 'Tab 2', content: <Component2 />, searchable: true },
 *   ]}
 *   onSearch={(query) => handleSearch(query)}
 * />
 */
const SettingsTabs = ({ tabs = [], defaultTab, showSearch = false, onSearch, searchPlaceholder = 'Search...', variant }) => {
  const [activeTab, setActiveTab] = useState(defaultTab || tabs.filter(Boolean)[0]?.id);
  const [searchQuery, setSearchQuery] = useState('');

  // Filter out null/undefined tabs
  const validTabs = tabs.filter(Boolean);

  if (validTabs.length === 0) return null;

  const activeTabData = validTabs.find(tab => tab.id === activeTab) || validTabs[0];

  const handleSearch = (e) => {
    const query = e.target.value;
    setSearchQuery(query);
    if (onSearch) {
      onSearch(query);
    }
  };

  return (
    <div className={`custom-tabs ${variant === 'card' ? 'custom-tabs--card' : ''}`}>
      <div className="custom-tabs__header">
        <div className="custom-tabs__nav">
          {validTabs.map((tab) => (
            <button
              key={tab.id}
              type="button"
              className={`custom-tabs__tab ${activeTab === tab.id ? 'custom-tabs__tab--active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.icon && <span className="custom-tabs__tab-icon">{tab.icon}</span>}
              <span className="custom-tabs__tab-label">{tab.label}</span>
            </button>
          ))}
        </div>
        {showSearch && (
          <div className="custom-tabs__search">
            <FontAwesomeIcon icon={faSearch} className="custom-tabs__search-icon" />
            <input
              type="text"
              className="custom-tabs__search-input"
              placeholder={searchPlaceholder}
              value={searchQuery}
              onChange={handleSearch}
            />
          </div>
        )}
      </div>
      <div className="custom-tabs__content">
        {typeof activeTabData?.content === 'function'
          ? activeTabData.content({ searchQuery })
          : activeTabData?.content}
      </div>
    </div>
  );
};

export default SettingsTabs;
